exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".heart-empty___VJdDB {\n  color: #0070ba;\n}\n.heart-filled___1q0zx {\n  color: #c1281b;\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/components/SetPreferredHeart/SetPreferredHeart.less"],"names":[],"mappings":"AAAA;EACE,eAAe;CAChB;AACD;EACE,eAAe;CAChB","file":"SetPreferredHeart.less","sourcesContent":[".heart-empty {\n  color: #0070ba;\n}\n.heart-filled {\n  color: #c1281b;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"heart-empty": "heart-empty___VJdDB",
	"heart-filled": "heart-filled___1q0zx"
};